<template>
	<div>
		<div class="header">
			<div class="header1" @click="fanhui">
				<img :src="logo" alt="" srcset="" style="width:40px;height:40px;margin-right:10px;"/>
				<h2>{{site_title}}</h2>
			</div>
			<div class="header2" @click="fanhui">
				<i class="el-icon-arrow-left"></i> 返回
			</div>
		</div>
		<div style="width:100%;height:90px;"></div>
		<div class="box">
			<h2>{{datails.name}}</h2>
			<div v-html="datails.content"></div>
		</div>
	</div>
</template>

<script>
	import {getProtocal} from '@/api/api'
	export default {
	  name: 'HelloWorld',
	  data() {
	    return {
			 site_title:"",
			 logo:"",
			 datails:""
	    }
	  },
	   computed: {
		   type() {
		     return this.$route.query.type || ''
		   },
	   },
	  created() {
		this.logo = localStorage.getItem("login")
		this.site_title = localStorage.getItem("site_title")
		this.getAgreement()
	  },
	  methods: {
		  fanhui(){
			 this.$router.go(-1) 
		  },
		  getAgreement(){
			  let types=""
			  if(this.type==1){
				  types='privacy'
			  }
			  if(this.type==2){
			  		 types='user'		  
			  }
			  if(this.type==3){
			  		 types='platform'		  
			  }
			  if(this.type==4){
			  		 types='review'		  
			  }
			  if(this.type==5){
			  		 types='distribution'		  
			  }
			  getProtocal({
				  code:types
			  }).then(res=>{
				  this.datails=res.data.data
			  })
		  }
	  },

	}
</script>
<style scoped>
	.header{
		width:100%;
		height:80px;
		position:fixed;
		top: 0;
		background-color:#fff;
		display:flex;
		align-items: center;
		justify-content: center;
		
	}
	.header1{
		width:1200px;
		height:80px;
		display:flex;
		align-items: center;
		cursor: pointer;
	}
	.header2{
		width:80px;
		height:30px;
		background: #2650d8;
		color: #ffffff;
		display:flex;
		align-items: center;
		justify-content: center;
		border-radius:6px;
		cursor: pointer;
	}
	.box{
		width:1200px;
		margin:0 auto;
		background-color:#fff;
		border-radius:12px;
		padding:24px;
		margin-bottom:30px;
	}
	.box h2{
		width:100%;
		line-height:60px;
		text-align: center;
	}
</style>